import { render } from "./Canvas.vue?vue&type=template&id=a7a0cde8&scoped=true&ts=true"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"

import "./Canvas.vue?vue&type=style&index=0&id=a7a0cde8&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a0cde8"]])

export default __exports__